export const BUSINESS_CATEGORIES = `
Accounting
Aerospace
Agriculture & Forestry
Arts & Entertainment
Automotive
Banking
Biotech
Business Services
Chiropractic
Construction
Consumer Products & Services
Education
Engineering
Entertainment & Events
Fashion & Apparel
Financial Services
Fitness & Wellness
Government
Healthcare
Hospitality
Information Technology
Insurance
Legal
Manufacturing
Marketing & Advertising
Massage
Media
Medical & Dental
Non-Profit Organization
Oil & Gas
Other Services
Personal Care & Services
Pharmaceuticals
Photo & Video
Politics
Printing & Publishing
Real Estate
Recruiting & Staffing
Restaurant & Food Services
Retail
Security
Technology
Telecommunications & Wireless
Transportation & Shipping
Travel & Leisure
`.split('\n').filter(l => l.length > 0);
